"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ContactType = exports.EmailType = void 0;
var EmailType;
(function (EmailType) {
    EmailType["DUMMY"] = "DUMMY";
    EmailType["CONTACT"] = "CONTACT";
    EmailType["SURVEY"] = "SURVEY";
})(EmailType || (exports.EmailType = EmailType = {}));
var ContactType;
(function (ContactType) {
    ContactType["REQUEST_DEMO"] = "REQUEST_DEMO";
    ContactType["PARTNERSHIP"] = "PARTNERSHIP";
    ContactType["GET_QUOTATION"] = "GET_QUOTATION";
    ContactType["APPLY_FOR_TIER"] = "APPLY_FOR_TIER";
})(ContactType || (exports.ContactType = ContactType = {}));
//# sourceMappingURL=eml.js.map